import React, { useContext } from 'react';
import InputFields from '../InputFields/InputFields';
import { IWordingsGroup } from 'types';
import { BtnBlock } from './components/BtnBlock';
import { IWordingsContext, WordingsContext } from '../../../wordingsState/wordingsContext';

const Form: React.FC = () => {
	const {
		clearInvalidFields,
		addInvalidField,
		setDataForSubmit,
		changeTypeOfModalWindow,
		groups,
		selectedLanguage,
		availableLanguages,
	} = useContext<IWordingsContext>(WordingsContext);

	const submit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		clearInvalidFields();
		const formData = new FormData(e.target as HTMLFormElement);
		const formValues = Object.fromEntries(formData) as { [key: string]: string };
		let isAllowToSubmit = true;

		let finalGroups: IWordingsGroup[] = groups;

		for (const formValuesKey in formValues) {
			const [groupId, itemKey, translationId, isRequired] = formValuesKey.split('/');
			if (!formValues[formValuesKey] && isRequired === 'true') {
				addInvalidField(formValuesKey);
				isAllowToSubmit = false;
			}
			finalGroups = finalGroups.map((group) =>
				group.id === groupId
					? {
							...group,
							items: group.items.map((item) =>
								item.key === itemKey
									? {
											...item,
											translations: item.translations.map((trans) =>
												trans.languageId === translationId
													? { ...trans, value: formValues[formValuesKey] }
													: trans,
											),
									  }
									: item,
							),
					  }
					: group,
			);
		}

		if (isAllowToSubmit) {
			setDataForSubmit({
				groups: finalGroups,
			});
			changeTypeOfModalWindow('toConfirmSubmit');
		}
	};

	return (
		<form name="wordings" onSubmit={submit}>
			{availableLanguages.map((el) => (
				<React.Fragment key={el.id}>
					{selectedLanguage?.id === el.id && <InputFields languageId={el.id} />}
				</React.Fragment>
			))}
			{/* TODO update service not implemented on BE */}
			{/*<BtnBlock />*/}
		</form>
	);
};

export default Form;
